import { render, staticRenderFns } from "./FacultativeReinsuranceBordereau.vue?vue&type=template&id=37363089&"
import script from "./FacultativeReinsuranceBordereau.vue?vue&type=script&lang=js&"
export * from "./FacultativeReinsuranceBordereau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports